module.exports = __webpack_public_path__ + "img/icon_grfx.867ffd08.png";